import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import Loader from "../../components/Loader";
import emptyStateImage from "../../images/dashboard/empty-state.png";
import InvestmentSchedulesTable from "./AllInvestmentSchedulesTable";
import OverviewDataCards from './OverviewDataCards';
import TotalIcon from "../../images/dashboard/icon-total.png";
import CompleteIcon from "../../images/dashboard/icon-completed.png";
import AuditIcon from "../../images/dashboard/icon-audits.png";
import iconAdd from "../../images/Icons-add.png";
import { useNavigate } from "react-router-dom";
import './index.scss';

// Dummy data for investment schedules
const dummyInvestmentSchedules = [
  { id: 1, clientName: "Baran Investments", analysisYear: "2024", status: "Completed" },
  { id: 2, clientName: "Venture Growth Partners", analysisYear: "2024", status: "In Progress" },
  { id: 3, clientName: "Tech Innovation Fund", analysisYear: "2024", status: "Completed" }
];

function InvestmentSchedules() {
  const [loading, setLoading] = useState(true);
  const [investmentSchedules, setInvestmentSchedules] = useState([]);
  const navigate = useNavigate();

  const [isChecked, setIsChecked] = useState(false);
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);

  useEffect(() => {
    // Simulate API call with dummy data
    setTimeout(() => {
      setInvestmentSchedules(dummyInvestmentSchedules);
      setLoading(false);
    }, 1000);
  }, []);

  const handleEditClick = (engagementId) => {
    setSelectedScheduleId(engagementId);
    navigate(`/investment-schedules/details/${engagementId}`);
  };

  const handleAction = () => {
    navigate('/investment-schedules/create-new-analysis');
  };

  const handleToggle = (value) => {
    setIsChecked(value);
  };


  return (
    loading ? (<Loader />) : (
      <>
        <Card className="px-3 py-4 mb-4 client-header" style={{ border: '1px solid #ECEEF5' }}>
          <Row>
            <Col className="my-auto">
            </Col>
            <Col className="my-auto mt-md-0 d-flex justify-content-end">
              <Button
                variant="primary"
                size="md"
                className="px-4 fw-bold"
                onClick={handleAction}
              >
                <img src={iconAdd} alt="add" className="me-2 my-auto" />
                Create New Analysis
              </Button>
            </Col>
          </Row>
        </Card>

        <Container fluid className="my-4">

          {investmentSchedules.length === 0 ? (
            <Row className="justify-content-center text-center my-5">
              <Col md={12}>
                <Card className="shadow-sm border-0 py-5">
                  <Card.Body className="d-flex flex-column align-items-center">
                    <Image src={emptyStateImage} alt="No Data" className="img-fluid mb-4" style={{ maxHeight: '200px' }} />
                    <div style={{ backgroundColor: '#F6F6FB', maxWidth: '500px' }} className="p-4 rounded">
                      <Card.Title className="text-dark fw-bold mb-3">Investment Schedule Management</Card.Title>
                      <p className="text-muted mb-4">No investment schedules available in the system. Start adding investment schedules to manage your analyses.</p>
                      <Button variant="primary"
                        className="border-0 text-white px-4 py-2" onClick={handleAction}>
                        Create New Analysis
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>  
            </Row>
          ) : (
            <Row>
              <Col>
                <InvestmentSchedulesTable
                  isChecked={isChecked}
                  onEditClick={handleEditClick}
                />
              </Col>
            </Row>
          )}

        </Container>
      </>
    )
  );
}

export default InvestmentSchedules;